/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Collectionindex_Description1Inputs */

const en_seo_collectionindex_description1 = /** @type {(inputs: Seo_Collectionindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore curated collections of AI tools grouped by workflow, use case, or topic.`)
};

const zh_seo_collectionindex_description1 = /** @type {(inputs: Seo_Collectionindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按工作流、使用场景或主题探索精选 AI 工具合集。`)
};

/**
* | output |
* | --- |
* | "Explore curated collections of AI tools grouped by workflow, use case, or topic." |
*
* @param {Seo_Collectionindex_Description1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_collectionindex_description1 = /** @type {((inputs?: Seo_Collectionindex_Description1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Collectionindex_Description1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_collectionindex_description1(inputs)
	return zh_seo_collectionindex_description1(inputs)
});
export { seo_collectionindex_description1 as "seo.collectionIndex.description" }